<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select v-model="formDatas.qttId" clearable placeholder="请选择类型" @change="partserch">
                        <el-option v-for="(item, index) in qttarr" :label="item.qttName" :value="item.qttId"
                            :key="index">
                        </el-option>
                    </el-select>

                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="bulkImport = true">批量上传</el-button>
                        <el-button type="danger" 
                        @click="BulkDelete">批量删除</el-button>
                    <!-- <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="claimClicks(4)">批量审核</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新建试题</el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="qtId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit ? '编辑试题' : '新增试题'" :visible.sync="dialog" width="70%" top="8vh">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:65vh">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">

                        <el-form-item label="试题名称" label-width="100" prop="qtName">
                            <el-input v-model="form.qtName" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="试题类型" label-width="100" prop="qttId">
                            <el-select v-model="form.qttId" clearable placeholder="请选择类型" @change="qttIdChange">
                                <el-option v-for="(item, index) in qttarr" :label="item.qttName" :value="item.qttId"
                                    :key="index" @click.native="theOption(item.qttScoreDefault)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="排序" label-width="100" prop="qtOrder">
                            <el-input v-model="form.qtOrder" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="试题分数" label-width="100" prop="qtScore">
                            <el-input v-model="form.qtScore" autocomplete="off"></el-input>
                        </el-form-item>
                        <!-- 单选 -->
                        <el-form-item v-if="theQttId == 1">
                            <div xstyle="border: 1px solid black;">
                                <el-button style="margin-left:10px;" type="primary" round size="small"
                                    class="el-icon-circle-plus" @click="toAddArray">
                                    添加
                                </el-button>
                                <el-table :data="array" border highlight-current-row :header-cell-style="{
                        textAlign: 'center',
                        background: 'rgba(0,170,255,0.5)',
                        color: 'black',
                        border: 'none'
                    }" style="width: 100%;margin:12px 0 0 0;">
                                    <el-table-column type="index" label="单选" align="center" width="80">
                                        <template slot-scope="scope">
                                            <el-radio v-model="currentRowId" :label="scope.row.id"
                                                @change="changeRadio($event, scope.row)">&nbsp;</el-radio>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="内容" align="center">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.qtiValue" size="medium"
                                                style="padding:7px;"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" align="center" width="100">
                                        <template slot-scope="scope">
                                            <el-button type="danger" size="small" round class="el-icon-delete"
                                                @click="toDeleteArray(scope.$index, scope.row)"> 删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form-item>
                        <!-- 判断 -->
                        <el-form-item v-if="theQttId == 3">
                            <div>
                                <el-button style="margin-left:10px;" type="primary" round size="small"
                                    class="el-icon-circle-plus" @click="toAddArray">
                                    添加
                                </el-button>
                                <el-table :data="array" border highlight-current-row :header-cell-style="{
                        textAlign: 'center',
                        background: 'rgba(0,170,255,0.5)',
                        color: 'black',
                        border: 'none'
                    }" style="width: 100%;margin:12px 0 0 0px;">
                                    <el-table-column type="index" label="判断" align="center" width="80">
                                        <template slot-scope="scope">
                                            <el-radio v-model="currentRowId" :label="scope.row.id"
                                                @change="changeRadio($event, scope.row)">&nbsp;</el-radio>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="内容" align="center">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.qtiValue" size="medium"
                                                style="padding:7px;"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" align="center" width="100">
                                        <template slot-scope="scope">
                                            <el-button type="danger" size="small" round class="el-icon-delete"
                                                @click="toDeleteArray(scope.$index, scope.row)"> 删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form-item>
                        <!-- 多选 -->
                        <el-form-item v-if="theQttId == 2">
                            <div>
                                <el-button style="margin-left:10px;" type="primary" round size="small"
                                    class="el-icon-circle-plus" @click="toAddArray">
                                    添加
                                </el-button>
                                <el-table :data="array" border highlight-current-row :header-cell-style="{
                        textAlign: 'center',
                        background: 'rgba(0,170,255,0.5)',
                        color: 'black',
                        border: 'none'
                    }" style="width: 100%;margin:12px 0 0 0px;" ref="multipleTables"
                                    @selection-change="handleSelectionChange">
                                    <el-table-column type="selection" width="80" label="多选"></el-table-column>
                                    <el-table-column label="内容" align="center">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.qtiValue" size="medium"
                                                style="padding:7px;"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" align="center" width="100">
                                        <template slot-scope="scope">
                                            <el-button type="danger" size="small" round class="el-icon-delete"
                                                @click="toDeleteArray(scope.$index, scope.row)"> 删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="theQttId == 4">
                            <div>
                                <el-input style="width: 100%;margin-left:0px;" v-model="theAnswer"
                                    placeholder="请输入答案"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="theQttId == 5">
                            <div>
                                <el-input style="width: 100%;margin-left:0px;" type="textarea" :rows="4"
                                    v-model="theAnswer" placeholder="请输入答案"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 批量导入 -->
            <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size="medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/teampk/excel/templatexjdt.xlsx', 'teampk')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>

import {
    addPkqTopic, deletePkqTopic, getPkqTopicList, updatePkqTopic, getPkqTopicTypeList,
    uploadPkqTopic, getNcClueList, getNcNicheList, getNcNicheProjectList,

} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            bulkData: [],
            bulkImport: false,

            theSearchQttId: '', // 单选题  多选题  判断题  填空题  简答题
            theAnswer: '', // 填空,简答的答案
            currentRowId: 1,
            currentRowIdMulti: 1,
            array: [
                { qtiValue: 'A.', qtiIsAnswer: 1, id: 1 }
            ],
            theQttId: '',
            ittarr: [],
            qttarr: [],
            topicArr: [],
            postForm: {},
            fromArr: [],
            limit: 1,
            visitfileList: [],
            getNcVisitorItemList_data: [],
            getNcVisitorList_data: [],
            userarr: [],
            level_Four: [],
            level_Three: [],
            key: 'qtId',
            dialog: false,
            edit: false,
            form: {

            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columnsImport: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "status",
                    key: "status",
                    title: "状态",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                    filter: {
                        filterList: [
                            { value: 0, label: '成功', selected: false },
                            { value: 1, label: '失败', selected: false },
                            { value: 3, label: '信息不完整', selected: false }
                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            //console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            this.searchByNameField(labels, 'status');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameField([]);
                        },
                        // max height
                        maxHeight: 120,
                    },
                },
                {
                    field: "statusMsg",
                    key: "statusMsg",
                    title: "状态备注",
                    width: 150,
                    align: "center",
                    fixed: 'left',

                },
                {
                    field: "qtName",
                    key: "qtName",
                    fixed: 'left',
                    title: "试题名称",
                    width: 150,
                    align: "center",
                    edit: false,

                },
                {
                    field: "qtcName",
                    key: "qtcName",
                    title: "分类",
                    width: 150,
                    align: "center",
                    edit: false,

                },
                {
                    field: "qttName",
                    key: "qttName",
                    title: "试题类型",
                    width: 150,
                    align: "center",
                    edit: false,

                },
                {
                    field: "qtOrder",
                    key: "qtOrder",
                    title: "排序",
                    width: 150,
                    align: "center",
                    edit: false,

                },
                {
                    field: "itemOne",
                    key: "itemOne",
                    title: "选项1",
                    width: 250,
                    align: "center",
                    edit: false,
                },
                {
                    field: "itemTwo",
                    key: "itemTwo",
                    title: "选项2",
                    width: 250,
                    align: "center",
                    edit: false,
                },
                {
                    field: "itemThree",
                    key: "itemThree",
                    title: "选项3",
                    width: 250,
                    align: "center",
                    edit: false,
                },
                {
                    field: "itemFour",
                    key: "itemFour",
                    title: "选项4",
                    width: 250,
                    align: "center",
                    edit: false,
                },
                {
                    field: "qtAnswer",
                    key: "qtAnswer",
                    title: "答案",
                    width: 250,
                    align: "center",
                    edit: false,
                },
            ],
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },

                {
                    field: "qtName",
                    key: "qtName",
                    fixed: 'left',
                    title: "试题名称",
                    width: 400,
                    align: "center",
                    edit: false,

                },
                // {
                //     field: "qtcName",
                //     key: "qtcName",
                //     title: "分类",
                //     width: 80,
                //     align: "center",
                //     edit: false,

                // },
                {
                    field: "qttName",
                    key: "qttName",
                    title: "试题类型",
                    width: 80,
                    align: "center",
                    edit: false,

                },
                {
                    field: "qtOrder",
                    key: "qtOrder",
                    title: "排序",
                    width: 50,
                    align: "center",
                    edit: false,

                },
                {
                    field: "pkqTopicItemList",
                    key: "pkqTopicItemList",
                    title: "题目选项",
                    // width: 250,
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div>
                                {
                                    row.pkqTopicItemList.map(item => {
                                        const str = <div style={{ color: item.qtiIsAnswer == 2 ? 'green' : 'black' }} >{item.qtiValue}</div>
                                        return str
                                    })
                                }
                            </div>
                        );
                    },
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        编辑
                                    </el-button>
                                }
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                yqtId: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        getPkqTopicList().then((res) => {
            this.topicArr = res.data;
        });
        getPkqTopicTypeList().then((res) => {
            this.qttarr = res.data;
        });

    },
    mounted() { },
    methods: {
           // 批量删除
           BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deletePkqTopic({ qtIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        async updatabulk(file, fileList) {
            //console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadPkqTopic(Data).then(res => {
                //console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data
            })
        },
        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        toAddArray() {
            if (this.theQttId == 3 && this.array.length >= 2) {
                this.$message({
                    message: '不能再添加了',
                    type: 'warning'
                })
                return
            }
            if (this.theQttId == 3) {
                this.array.push({ qtiValue: '错', qtiIsAnswer: 1, id: 1 })
                return
            }
            this.array.push({ qtiValue: '', qtiIsAnswer: 1, id: this.array.length + 1 })
        },
        // 删除选项
        toDeleteArray(index, row) {
            if (this.array.length == 1) {
                return
            }
            this.array.splice(index, 1)
        },
        handleSelectionChange(val) {
            this.currentRowIdMulti = val
        },
        changeRadio(event, row) {
            this.currentRowId = event
        },
        async qttIdChange(e) {
            this.array = [
                { qtiValue: 'A.', qtiIsAnswer: 1, id: 1 }
            ],
                //console.log(this.array)
                this.theQttId = ''
            await this.$nextTick()
            this.theQttId = e
            if (e == 3) {
                this.array = [{ qtiValue: '对', qtiIsAnswer: 1, id: 1 }]
            }
        },
        theOption(data) {
            this.form.qtScore = data

            //console.log('a')
        },
        getPost(key) {
            const userpost = JSON.parse(sessionStorage.getItem('userPost')) || [];
            userpost.forEach((item, index) => {
                if (item.nsaMenuKey == key) {
                    this.postForm[item.nsaFuncKey] = item.nsaFuncLabel
                }
            })
        },
        fromChange(e) {
            this.fromArr = [];
            if (e == 1) {
                getNcClueList({ pageSize: 0 }).then((res) => {
                    res.data.forEach((item, index) => {
                        const s = {
                            name: item.ncName,
                            id: item.ncId
                        }
                        this.fromArr.push(s)
                    })
                });
            } else if (e == 2) {
                getNcNicheList({ pageSize: 0 }).then((res) => {
                    res.data.forEach((item, index) => {
                        const s = {
                            name: item.nnName,
                            id: item.nnId
                        }
                        this.fromArr.push(s)
                    });
                })
            } else {
                getNcNicheProjectList({ pageSize: 0 }).then((res) => {
                    res.data.forEach((item, index) => {
                        const s = {
                            name: item.nnpName,
                            id: item.nnpId
                        }
                        this.fromArr.push(s)
                    });
                })
            }
        },
        visitfileChange(file) {
            this.$set(this.form, 'nvsFiles', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },

        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deletePkqTopic({ qtId: row.qtId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.theQttId = data.qttId
                switch (this.theQttId) {
                    case 1:
                    case 3:
                        // 单选题 判断题
                        this.array = data.pkqTopicItemList
                        // 设置选中
                        this.array.forEach((element, index) => {
                            element.id = index + 1
                            if (element.qtiIsAnswer == 2) {
                                element.qtiIsAnswer = 2
                                this.currentRowId = element.id
                            }
                        })
                        break
                    case 2:
                        // 多选题
                        this.theQttId = 2
                        this.array = data.pkqTopicItemList
                        // 设置选中
                        this.$nextTick(() => {
                            this.array.forEach((element, index) => {
                                element.id = index + 1
                                if (element.qtiIsAnswer == 2) {
                                    element.qtiIsAnswer = 2
                                    this.$refs.multipleTables.toggleRowSelection(this.array[index], true)// 默认选中
                                }
                            })
                        })
                        break
                    case 4:
                    case 5:
                        // 填空题  简答题
                        this.theAnswer = data.pkqTopicItemList[0].qtiValue
                        break
                }
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        // 单选题  多选题  判断题  填空题  简答题
                        switch (this.theQttId) {
                            case 1:
                            case 3:
                                this.array.forEach(element => {
                                    if (element.id == this.currentRowId) {
                                        element.qtiIsAnswer = 2
                                    }
                                    if (element.qtiValue == null || element.qtiValue == '') {
                                        this.$message({
                                            message: '选项不能为空',
                                            type: 'warning'
                                        })
                                    }
                                })
                                break
                            case 2:
                                // 多选
                                this.array.forEach(element => {
                                    if (element.qtiValue == null || element.qtiValue == '') {
                                        this.$message({
                                            message: '选项不能为空',
                                            type: 'warning'
                                        })
                                    }
                                    this.currentRowIdMulti.forEach(item => {
                                        // 设置答案
                                        if (element.id == item.id) {
                                            element.qtiIsAnswer = 2
                                        }
                                    })
                                })
                                break
                            case 4:
                            case 5:
                                this.array = [{ qtiValue: this.theAnswer, qtiIsAnswer: 2 }]
                                break
                        }

                        this.form.pkqTopicItemListString = JSON.stringify(this.array)
                        addPkqTopic(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        switch (this.theQttId) {
                            case 1:
                            case 3:
                                this.array.forEach(element => {
                                    if (element.id == this.currentRowId) {
                                        element.qtiIsAnswer = 2
                                    }
                                    if (element.qtiValue == null || element.qtiValue == '') {
                                        this.$message({
                                            message: '选项不能为空',
                                            type: 'warning'
                                        })
                                    }
                                })
                                break
                            case 2:
                                // 多选
                                this.array.forEach(element => {
                                    if (element.qtiValue == null || element.qtiValue == '') {
                                        this.$message({
                                            message: '选项不能为空',
                                            type: 'warning'
                                        })
                                    }
                                    this.currentRowIdMulti.forEach(item => {
                                        // 设置答案
                                        if (element.id == item.id) {
                                            element.qtiIsAnswer = 2
                                        }
                                    })
                                })
                                break
                            case 4:
                            case 5:
                                this.array = [{ qtiValue: this.theAnswer, qtiIsAnswer: 2 }]
                                break
                        }

                        this.form.pkqTopicItemListString = JSON.stringify(this.array)
                        updatePkqTopic(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.theQttId = ''
            this.$refs['formRef'].resetFields();

        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.qtId = row.qtId
                    //console.log(jsonObj);
                    updatePkqTopic(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getPkqTopicList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getPkqTopicList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getPkqTopicList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>